<template>
  <InputRadioGroup
    legend="Abonnemang"
    extra-legend="Hur många är ni?"
    extra-legend-second="Ett abonnemang eller familjeabonnemang."
    type-class="product-page"
  >
    <InputRadioButton
      id="no-family"
      v-model="familySelect"
      value="no-family"
      label="Bara jag"
      aria-label="Bara jag köper abonnemang, lägg inte till familjeabonnemang"
      :simple-label="true"
      :group-name="`family-${groupNameId}`"
    />
    <InputRadioButton
      id="family"
      v-model="familySelect"
      value="add-family"
      label="Vi är fler"
      aria-label="Vi är fler, lägg till familjeabonnemang"
      :simple-label="true"
      :group-name="`family-${groupNameId}`"
      @click="familySelect = 'add-family'"
    />
  </InputRadioGroup>
  <PdpFamilyPlanSummaryTable />
</template>

<script lang="ts" setup>
const familyStore = useFamilyStore();
const productPageStore = useMyProductPageStore();
const { ui: familyStoreUi } = storeToRefs(familyStore);
const groupNameId = useId();

const familySelect: Ref<'no-family' | 'add-family'> = ref('no-family');

watch(familySelect, (value) => {
  if (value === 'add-family') {
    familyStore.showFamilyDrawerPdpStart();
  } else {
    familyStore.ui.showFamilyAddedPdp = false;
    productPageStore.resetStateAfterFamilyDeselection();
  }
});

watch(
  familyStoreUi,
  (familyUiValue) => {
    if (
      !familyUiValue.showFamilyDrawer &&
      familySelect.value === 'add-family' &&
      !familyUiValue.showFamilyAddedPdp
    ) {
      familySelect.value = 'no-family';
    }
  },
  { deep: true },
);
</script>

<style lang="scss" scoped></style>
